import React, { useEffect, useState } from "react";
import "./../NewJobOpenings/NewJobOpenings.css";
import { CiLocationOn, CiDollar } from "react-icons/ci";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import axiosInstance from "../../api/axiosInstance";
import { formatSalary } from "../../utils/formatSalary";
import { getPreloadedData, PreloadedScript } from "../../utils/preloadedData";

const createSlug = (title) => {
  if (!title) return "";
  return title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "") // Remove special characters
    .trim()
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-"); // Replace multiple hyphens with single hyphen
};

function NewJobOpenings() {
  const navigate = useNavigate();
  // Seeded from the prerendered snapshot so the first client render matches the static HTML.
  const [jobs, setJobs] = useState(() => getPreloadedData("__PRELOADED_JOB_LIST__") || []);
  const [loading, setLoading] = useState(() => getPreloadedData("__PRELOADED_JOB_LIST__") === null);
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 8;

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axiosInstance.get("/api/jobs");
        setJobs(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Failed to fetch jobs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  const jobDescription = (job) => {
    navigate(`/job/description/${job.id}/${createSlug(job.title)}`);
  };

  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = jobs.slice(indexOfFirstJob, indexOfLastJob);
  const totalPages = Math.ceil(jobs.length / jobsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      window.scrollTo(0, 0);
    }
  };

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  // Display loader while fetching data
  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    );
  }

  return (
    <div className="main_div_newjobopenings">
      <PreloadedScript id="__PRELOADED_JOB_LIST__" data={jobs} />
       <Helmet>
         
                 <title>Tech Careers & Job Openings | 360 SynergyTech</title>
                 <link rel="canonical" href="https://360synergytech.com/careers" />

                 <meta property="og:title" content="Tech Careers & Job Openings | 360 SynergyTech" />
                 <meta property="og:url" content="https://360synergytech.com/careers" />
                 <meta property="og:image" content="https://360synergytech.com/header111.jpg" />
                 <meta property="og:description" content="Join 360 SynergyTech and build your career in IT, software engineering, AI, and cloud solutions. Apply now to be part of an innovative technology team." />

                 <meta name="twitter:card" content="summary_large_image" />
                 <meta name="twitter:title" content="Tech Careers & Job Openings | 360 SynergyTech" />
                 <meta name="twitter:description" content="Kickstart your career in AI, cloud, and IT solutions. Apply today." />
                 <meta name="twitter:image" content="https://360synergytech.com/header111.jpg" />

        

        <meta name="description" content="Ready to level up your tech career? Explore growth-driven roles at 360 SynergyTech and join a team shaping digital innovation." />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            // schema.org has no "CareerPage" type; the careers listing is a CollectionPage of job postings.
            "@type": "CollectionPage",
            name: "Careers at 360 SynergyTech",
            url: "https://360synergytech.com/careers",
            description: "Ready to level up your tech career? Explore growth-driven roles at 360 SynergyTech and join a team shaping digital innovation.",
            isPartOf: { "@type": "WebSite", name: "360 SynergyTech", url: "https://360synergytech.com/" },
            publisher: { "@type": "Organization", name: "360 SynergyTech", url: "https://360synergytech.com/" },
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "Home", item: "https://360synergytech.com/" },
              { "@type": "ListItem", position: 2, name: "Careers", item: "https://360synergytech.com/careers" },
            ],
          })}
        </script>
      </Helmet>
      <div className="d-flex justify-content-center">
        <div className="new_opening_div_hr"></div>
      </div>
      <div className="row m-0 p-0">
        <div className="col-lg-2 col-md-1 col-sm-12 col-12"></div>
        <div className="col-lg-8 col-md-10 col-sm-12 col-12">
         
          <h1 className="new_opening_para"> Grow Your Tech Career with 360 SynergyTech | New Openings</h1><br/><br/>
          <h2 className="new_opening_heading">Explore Exciting Opportunities in AI, Web, and Cloud </h2><h2 className="new_opening_heading"> Development</h2>
          
          <div className="row">
            {currentJobs.map((job) => (
              <div className="col-lg-6 col-md-6 col-sm-12 col-12" key={job.id}>
                <div className="main_div_job_open_card">
                  <div className="row p-0 m-0 align-items-center">
                    <div className="col-lg-8 col-md-9 col-sm-12 col-12">
                      {/* Job title as h4 */}
                      <h3 className="heading_position_name">
                        <Link to={`/job/description/${job.id}/${createSlug(job.title)}`} style={{ color: "inherit", textDecoration: "none" }}>
                          {truncateText(job.title, 40)}
                        </Link>
                      </h3>
                      <div className="d-flex flex-row flex-wrap align-items-center job_meta_row">
                        <span className="by_grey_job_desp">By</span>
                        <h4 className="black_para_job_desp" style={{ display: "inline", fontWeight: 600, margin: "0 5px 0 0" }}>360 SynergyTech</h4>
                        <span className="by_grey_job_desp">in</span>
                        <span className="by_orange_job_desp">{job.category}</span>
                      </div>
                      <div className="d-flex flex-wrap">
                        <span className="btn_in_house_job">{job.mode}</span>
                        <span className="btn_in_house_job">
                          <CiLocationOn />
                          {job.location}
                        </span>
                        <span className="btn_in_house_job">
                          <CiDollar />
                          {formatSalary(job.salary)}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-3 col-sm-12 col-12">
                      <button className="apply_now_btn_job" onClick={() => jobDescription(job)}>Apply Now</button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* Pagination */}
          {totalPages > 1 && (
            <div className="pagination_div" style={paginationStyles.container}>
              {[...Array(totalPages)].map((_, index) => {
                const pageNumber = index + 1;
                return (
                  <button
                    key={pageNumber}
                    onClick={() => handlePageChange(pageNumber)}
                    style={
                      currentPage === pageNumber
                        ? { ...paginationStyles.dot, ...paginationStyles.activeDot }
                        : paginationStyles.dot
                    }
                  >
                    {/* h5 for page number, visually styled as span */}
                    <span style={{ margin: 0, fontSize: 16, fontWeight: 600, display: "inline", lineHeight: 1.2 }}>{pageNumber}</span>
                  </button>
                );
              })}
            </div>
          )}
        </div>
        <div className="col-lg-2 col-md-1 col-sm-12 col-12"></div>
      </div>
    </div>
  );
}

const paginationStyles = {
  container: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
    marginBottom: "20px",
  },
  dot: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#e0e0e0",
    margin: "0 5px",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    color: "#333",
    transition: "background-color 0.3s",
  },
  activeDot: {
    backgroundColor: "#ff6809",
    color: "#fff",
  },
};

export default NewJobOpenings;